__turbopack_context__.v({
  "actions": "OrganizerInfo-module-scss-module__xhCNrq__actions",
  "avatar": "OrganizerInfo-module-scss-module__xhCNrq__avatar",
  "avatarBadge": "OrganizerInfo-module-scss-module__xhCNrq__avatarBadge",
  "avatarColumn": "OrganizerInfo-module-scss-module__xhCNrq__avatarColumn",
  "avatarInitial": "OrganizerInfo-module-scss-module__xhCNrq__avatarInitial",
  "bioBlock": "OrganizerInfo-module-scss-module__xhCNrq__bioBlock",
  "contactAction": "OrganizerInfo-module-scss-module__xhCNrq__contactAction",
  "cover": "OrganizerInfo-module-scss-module__xhCNrq__cover",
  "header": "OrganizerInfo-module-scss-module__xhCNrq__header",
  "headerWrap": "OrganizerInfo-module-scss-module__xhCNrq__headerWrap",
  "info": "OrganizerInfo-module-scss-module__xhCNrq__info",
  "infoContent": "OrganizerInfo-module-scss-module__xhCNrq__infoContent",
  "infoTop": "OrganizerInfo-module-scss-module__xhCNrq__infoTop",
  "locationsBlock": "OrganizerInfo-module-scss-module__xhCNrq__locationsBlock",
  "metricsBlock": "OrganizerInfo-module-scss-module__xhCNrq__metricsBlock",
  "mobileContactButton": "OrganizerInfo-module-scss-module__xhCNrq__mobileContactButton",
  "mobileTopOrganizerLabel": "OrganizerInfo-module-scss-module__xhCNrq__mobileTopOrganizerLabel",
  "nameRow": "OrganizerInfo-module-scss-module__xhCNrq__nameRow",
  "nameText": "OrganizerInfo-module-scss-module__xhCNrq__nameText",
  "premiumBadgeTrigger": "OrganizerInfo-module-scss-module__xhCNrq__premiumBadgeTrigger",
  "premiumNameEnd": "OrganizerInfo-module-scss-module__xhCNrq__premiumNameEnd",
  "premiumTooltip": "OrganizerInfo-module-scss-module__xhCNrq__premiumTooltip",
  "socialBlock": "OrganizerInfo-module-scss-module__xhCNrq__socialBlock",
  "superOrganizerNameRow": "OrganizerInfo-module-scss-module__xhCNrq__superOrganizerNameRow",
});
